/**
 * Shop by Size — client filter of collection products.
 * Uses MidwoodSizeMapper. No catalog writes.
 * In-stock is enforced per matched variant (available === true),
 * on every collection — mens / womens / all — not only /collections/in-stock.
 */
(function () {
  "use strict";

  var mapper = window.MidwoodSizeMapper;
  if (!mapper) {
    console.warn("Shop by Size: size-mapper.js missing");
    return;
  }

  var GENDER_WORD = { men: "Men's", women: "Women's", gs: "GS", td: "TD" };
  var DEFAULT_SIZES = {
    men:   [4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 13, 14],
    women: [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 12],
    gs:    [3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7],
    td:    [8, 9, 10, 11, 12, 13]
  };
  var EU_SIZES = [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46];

  var root = document.querySelector("[data-shop-by-size]");
  if (!root) return;

  var state = { gender: null, size: null, width: null, eu: null };
  var products = [];
  var localeReadable = false;
  var localeChecked = 0;
  var localePresent = 0;

  function fmt(n) { return mapper.fmtNum(n); }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  function variantInStock(v) {
    // Shopify available is the purchase flag. Do not gate on inventory_quantity
    // alone — untracked inventory is 0 while available is still true.
    // Hide OOS even when the host collection is mens / womens / all.
    return !!(v && v.available);
  }

  function hitInStock(h) {
    return !!(h && h.available);
  }

  function productHasInStockVariant(p) {
    return (p.variants || []).some(function (v) { return variantInStock(v); });
  }

  function sizeIndex(optionNames) {
    var names = optionNames || [];
    for (var i = 0; i < names.length; i++) {
      if (mapper.sizeOptionName(names[i])) return i;
    }
    return names.length ? 0 : -1;
  }

  function indexProduct(p) {
    var ctx = {
      title: p.title,
      vendor: p.vendor,
      sizeLocale: p.sizeLocale || "",
      type: p.type || "",
      tags: p.tags || [],
      handle: p.handle || ""
    };
    if (p.sizeLocale) localePresent += 1;
    localeChecked += 1;
    var idx = sizeIndex(p.optionNames);
    var hits = [];
    var labels = [];
    var euSizes = [];
    (p.variants || []).forEach(function (v) {
      var raw = idx >= 0 && v.options ? v.options[idx] : (v.options && v.options[0]);
      if (raw == null) return;
      var mapped = mapper.mapOption(raw, ctx);
      if (!mapped) return;
      var inStock = variantInStock(v);
      mapped.hits.forEach(function (h) {
        hits.push({
          gender: h.gender,
          size: h.size,
          width: h.width,
          locale: h.locale,
          available: inStock,
          inventory: typeof v.inventory === "number" ? v.inventory : null,
          label: mapped.storefront_label,
          raw: mapped.raw
        });
      });
      if (mapped.locale === "EU") euSizes.push(mapped.size_numeric);
      if (labels.indexOf(mapped.storefront_label) === -1) labels.push(mapped.storefront_label);
    });
    p._hits = hits;
    p._labels = labels;
    p._eu = euSizes;
    return p;
  }

  function parsePageJson(text) {
    try { return JSON.parse(text); } catch (e) { return null; }
  }

  function ingestPage(page) {
    if (!page || !page.products) return;
    if (page.sizeLocaleReadable) localeReadable = true;
    page.products.forEach(function (p) {
      if (products.some(function (x) { return x.id === p.id; })) return;
      products.push(indexProduct(p));
    });
  }

  function loadEmbedded() {
    root.querySelectorAll("script.js-sbs-page").forEach(function (el) {
      ingestPage(parsePageJson(el.textContent));
    });
  }

  function fetchRemaining(first) {
    var pages = first && first.pages ? first.pages : 1;
    if (pages <= 1) return Promise.resolve();
    var sectionId = root.getAttribute("data-section-id") || "shop-by-size";
    var jobs = [];
    for (var p = 2; p <= pages; p++) {
      (function (pageNum) {
        var u = new URL(location.href);
        u.searchParams.set("view", "shop-by-size");
        u.searchParams.set("page", String(pageNum));
        u.searchParams.set("section_id", sectionId);
        jobs.push(
          fetch(u.toString(), { credentials: "same-origin" })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, "text/html");
              doc.querySelectorAll("script.js-sbs-page").forEach(function (el) {
                ingestPage(parsePageJson(el.textContent));
              });
            })
            .catch(function (err) { console.warn("Shop by Size page load failed", pageNum, err); })
        );
      })(p);
    }
    return Promise.all(jobs);
  }

  function parseHash() {
    var raw = (location.hash || "").replace(/^#/, "");
    if (!raw) return;
    raw.split("&").forEach(function (part) {
      var kv = part.split("=");
      var k = decodeURIComponent(kv[0] || "");
      var v = decodeURIComponent(kv[1] || "");
      if (k === "g" && (v === "men" || v === "women" || v === "gs" || v === "td")) state.gender = v;
      if (k === "s" && v) state.size = parseFloat(v);
      if (k === "w" && (v === "standard" || v === "wide")) state.width = v;
      if (k === "eu" && v) {
        state.eu = parseFloat(v);
        state.gender = null;
        state.size = null;
      }
    });
    if (state.gender === "women" && state.size != null && !mapper.womenSizeAllowed(state.size)) {
      state.size = null;
    }
  }

  function writeHash() {
    var parts = [];
    if (state.eu != null) parts.push("eu=" + state.eu);
    if (state.gender) parts.push("g=" + state.gender);
    if (state.size != null) parts.push("s=" + state.size);
    if (state.width) parts.push("w=" + state.width);
    var next = parts.length ? "#" + parts.join("&") : "";
    if (location.hash !== next) {
      history.replaceState(null, "", location.pathname + location.search + next);
    }
  }

  function matches(p) {
    var pool = (p._hits || []).filter(hitInStock);
    if (state.eu != null) {
      return pool.some(function (h) { return h.locale === "EU" && h.size === state.eu; });
    }
    if (state.gender) pool = pool.filter(function (h) { return h.gender === state.gender; });
    if (state.size != null) pool = pool.filter(function (h) { return h.size === state.size; });
    if (state.width) pool = pool.filter(function (h) { return h.width === state.width; });
    if (state.gender || state.size != null || state.width) return pool.length > 0;
    return productHasInStockVariant(p);
  }

  function matchingLabel(p) {
    var pool = (p._hits || []).filter(hitInStock);
    if (!pool.length) pool = (p._hits || []).slice();
    if (state.eu != null) {
      pool = pool.filter(function (h) { return h.locale === "EU" && h.size === state.eu; });
    } else {
      if (state.gender) pool = pool.filter(function (h) { return h.gender === state.gender; });
      if (state.size != null) pool = pool.filter(function (h) { return h.size === state.size; });
      if (state.width) pool = pool.filter(function (h) { return h.width === state.width; });
    }
    if (pool[0] && pool[0].label) return pool[0].label;
    return p._labels[0] || "";
  }

  function hitsFor(gender) {
    var set = {};
    products.forEach(function (p) {
      p._hits.forEach(function (h) {
        if (h.gender === gender && hitInStock(h)) set[h.size] = true;
      });
    });
    return set;
  }

  function euHave() {
    var set = {};
    products.forEach(function (p) {
      p._hits.forEach(function (h) {
        if (h.locale === "EU" && hitInStock(h)) set[h.size] = true;
      });
    });
    return set;
  }

  function readoutText() {
    if (state.eu != null) return "EU " + fmt(state.eu);
    var bits = [];
    if (state.gender) bits.push(GENDER_WORD[state.gender]);
    if (state.size != null) bits.push(fmt(state.size));
    if (state.width === "wide") bits.push("Wide");
    if (state.width === "standard") bits.push("Standard");
    return bits.length ? bits.join(" · ") : "All loaded pairs";
  }

  function renderCards() {
    var grid = root.querySelector("[data-sbs-grid]");
    if (!grid) return;
    grid.innerHTML = "";
    var shown = products.filter(matches);
    shown.forEach(function (p) {
      var a = document.createElement("a");
      a.className = "sbs-card";
      a.href = p.url || ("/products/" + p.handle);
      var img = p.image
        ? '<div class="sbs-card__img"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></div>'
        : '<div class="sbs-card__img sbs-card__img--empty"></div>';
      a.innerHTML = img +
        '<div class="sbs-card__meta">' +
          '<div class="sbs-card__brand">' + esc(p.vendor) + '</div>' +
          '<div class="sbs-card__name">' + esc(p.title) + '</div>' +
          '<div class="sbs-card__label">' + esc(matchingLabel(p)) + '</div>' +
        '</div>';
      grid.appendChild(a);
    });
    if (!shown.length) {
      var empty = document.createElement("div");
      empty.className = "sbs-empty";
      empty.innerHTML = "<strong>No pairs</strong>Nothing in this collection matches that size filter.";
      grid.appendChild(empty);
    }
    var countEl = root.querySelector("[data-sbs-count]");
    var readEl = root.querySelector("[data-sbs-readout]");
    if (countEl) countEl.textContent = shown.length === 1 ? "1 pair" : shown.length + " pairs";
    if (readEl) readEl.textContent = readoutText();
  }

  function paintChips(sel, attr, current) {
    root.querySelectorAll(sel).forEach(function (b) {
      var v = b.getAttribute(attr);
      var on = current == null ? false : String(current) === v || Number(current) === Number(v);
      if (attr === "data-gender" || attr === "data-width") on = current === v;
      b.classList.toggle("on", !!on);
    });
  }

  function renderUsSizes() {
    var block = root.querySelector("[data-sbs-us]");
    var chips = root.querySelector("[data-sbs-us-chips]");
    var label = root.querySelector("[data-sbs-us-label]");
    if (!block || !chips) return;
    chips.innerHTML = "";
    if (!state.gender) {
      block.hidden = true;
      return;
    }
    block.hidden = false;
    if (label) {
      label.innerHTML = GENDER_WORD[state.gender] + ' size <span>gendered · no unisex 9</span>';
    }
    var avail = hitsFor(state.gender);
    var list = [];
    Object.keys(avail).forEach(function (k) {
      var n = parseFloat(k);
      if (state.gender === "women" && !mapper.womenSizeAllowed(n)) return;
      list.push(n);
    });
    list.sort(function (a, b) { return a - b; });
    list.forEach(function (sz) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "sbs-chip";
      if (state.size === sz) b.classList.add("on");
      b.setAttribute("data-size", String(sz));
      b.textContent = fmt(sz);
      b.addEventListener("click", function () {
        state.eu = null;
        state.size = state.size === sz ? null : sz;
        sync();
      });
      chips.appendChild(b);
    });
  }

  function paintEu() {
    var have = euHave();
    root.querySelectorAll("[data-eu]").forEach(function (b) {
      var v = parseFloat(b.getAttribute("data-eu"));
      var instock = !!have[v];
      b.classList.toggle("on", state.eu === v);
      b.classList.toggle("empty", !instock);
      b.hidden = !instock;
    });
  }

  function sync() {
    writeHash();
    paintChips("[data-gender]", "data-gender", state.gender);
    paintChips("[data-width]", "data-width", state.width);
    paintEu();
    renderUsSizes();
    renderCards();
  }

  function bind() {
    root.querySelectorAll("[data-gender]").forEach(function (b) {
      b.addEventListener("click", function () {
        var g = b.getAttribute("data-gender");
        if (state.gender === g) {
          state.gender = null;
          state.size = null;
        } else {
          state.gender = g;
          state.size = null;
          state.eu = null;
        }
        sync();
      });
    });
    root.querySelectorAll("[data-width]").forEach(function (b) {
      b.addEventListener("click", function () {
        var w = b.getAttribute("data-width");
        state.width = state.width === w ? null : w;
        sync();
      });
    });
    root.querySelectorAll("[data-eu]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseFloat(b.getAttribute("data-eu"));
        if (state.eu === v) {
          state.eu = null;
        } else {
          state.eu = v;
          state.gender = null;
          state.size = null;
        }
        sync();
      });
    });
  }

  function showLocaleStatus() {
    var el = root.querySelector("[data-sbs-locale]");
    if (!el) return;
    if (localePresent > 0) {
      el.hidden = false;
      el.classList.remove("sbs-locale--block");
      el.textContent = "SizeLocale readable in Liquid on " + localePresent + " / " + localeChecked + " products. Labels computed in the theme. Catalog unchanged.";
    } else if (localeChecked > 0) {
      el.hidden = false;
      el.classList.add("sbs-locale--block");
      el.textContent = "BLOCKER: StockX.SizeLocale was not readable in Liquid on these products. Storefront API access is NONE. Metafields were not written. Bare-number gender cannot be resolved.";
    }
  }

  var first = null;
  var firstEl = root.querySelector("script.js-sbs-page");
  if (firstEl) first = parsePageJson(firstEl.textContent);

  loadEmbedded();
  bind();
  parseHash();

  var loading = root.querySelector("[data-sbs-loading]");
  fetchRemaining(first).then(function () {
    if (loading) loading.hidden = true;
    showLocaleStatus();
    sync();
  });

  if (!first || !first.pages || first.pages <= 1) {
    if (loading) loading.hidden = true;
    showLocaleStatus();
    sync();
  }
})();
